import { memo } from 'react'
import { Handle, Position } from 'reactflow'
import type { NodeProps } from 'reactflow'

export interface RouterNodeData {
  label: string
  condition: string
}

export const RouterNode = memo(({ data }: NodeProps<RouterNodeData>) => {
  return (
    <div className="relative flex items-center justify-center w-[120px] h-[60px]">
      <Handle type="target" position={Position.Left} className="w-2 h-2" />
      <div
        className="absolute inset-0 rounded-md border-2 border-amber-400 bg-amber-50"
        style={{ transform: 'rotate(45deg) scale(0.7)' }}
      />
      <div className="relative z-10 text-center px-2">
        <p className="text-xs font-semibold text-amber-800 leading-tight">{data.label}</p>
        {data.condition && (
          <p className="text-xs text-amber-600 leading-tight">{data.condition}</p>
        )}
      </div>
      <Handle type="source" position={Position.Right} className="w-2 h-2" />
      <Handle type="source" id="bottom" position={Position.Bottom} className="w-2 h-2" />
    </div>
  )
})

RouterNode.displayName = 'RouterNode'
